import short_day_name_and_time from "../../../../library/utilities/Time/short_day_name_and_time";

class FlightTableUI {
  constructor(tableBody) {
    this.tableBody = tableBody;
  }

  clearTable() {
    this.tableBody.textContent = "";
  }

  appendTableRow(row) {
    this.tableBody.appendChild(row);
  }

  displayNoFlightsMessage() {
    this.tableBody.innerHTML = "<div>No flights found.</div>";
  }

  appendChild(element) {
    this.tableBody.appendChild(element);
  }

  displayLoadingSpinner(message) {
    this.tableBody.innerHTML = `<div class="loading-spinner" data-message="${message}"></div>`;
  }
}

export default class Manage_Flight_Track_Data {
  constructor(app, flight_data) {
    // DOM elements
    this.tabs = [...document.querySelectorAll(".flight-tab")];

    this.depature_column_header = document.querySelector('.flight-table-cell.arrival-departure.header');
    this.flight_search = document.getElementById("flight-search");
    this.sortableHeaders = [...document.querySelectorAll(".flight-table-cell.header i")];
    
    // Constructor variables
    this.app = app;
    this.flight_data = flight_data;

   
    
    // Global variables
    this.filtered_flight_data = [];
    this.filteredViaTabbed = false;
    this.searchFilteredArray = [];
    this.isFilteredViaSearch = false;
    this.search_timer;
    this.search_value;
    this.activeTab = "All";
   

    // Flight table UI
    this.flight_table_ui = new FlightTableUI(document.querySelector(".flight-table-body"));

    
  }

  init() {
    this.events();
  }

  events() {
    // Loop through tabs and add click listeners
    this.tabs.forEach((tab) => {
      this.app.clickListeners.push({
        element: tab,
        event: "click",
        function: this.tabClick.bind(this),
      });
    });
    
    // Add event listener to search input
    this.app.clickListeners.push({
      element: this.flight_search,
      event: "keyup",
      function: this.searchFlight.bind(this),
    });

    // Add click event listeners to sortable headers
    this.sortableHeaders.forEach((header) => {
      this.app.clickListeners.push({
        element: header,
        event: "click",
        function: this.sortFlights.bind(this),
      });
    });
  }

  tabClick(e) {
    
    let tab = e.target;
    let value = tab.textContent;
    
    // Check if active tab class is already on tab
    if (tab.classList.contains("active")) {
      return;
    } else {
      // Remove active class from all tabs
      this.tabs.forEach((tab) => {
        tab.classList.remove("active");
      });
      // Add active class to clicked tab
      tab.classList.add("active");
    }
    
    let open_close_class;

    // Choose correct flight data based on filter states
    if (this.isFilteredViaSearch) {
      this.filtered_flight_data = this.searchFilteredArray;
    }

    switch (value) {
      case "All":
        this.filterFlightsByADI();
        open_close_class = "open";
        this.setActiveTab("All");
        break;
      case "Arrivals":
        this.filterFlightsByADI("a", "close");
        open_close_class = "close";
        this.setActiveTab("a");
        break;
      case "Departures":
        this.filterFlightsByADI("d", "close");
        open_close_class = "close";
        this.setActiveTab("d");
        break;
    }

    this.updateDepartureColumnHeader(open_close_class);

    // Clear the table body
    this.flight_table_ui.clearTable();

    this.filtered_flight_data.forEach((flight) => {
      this.flight_table_ui.appendChild(this.tableRowCreator(flight, open_close_class));
    });
  }

  setActiveTab(tab) {
    this.activeTab = tab;
  }

  filterFlightsByADI(adiValue, openCloseClass) {
       if(!adiValue) {
          // check if search has a value
          if(this.search_value) {
            this.filtered_flight_data = this.searchFilteredArray;
            this.updateFlightFilter(true, this.filtered_flight_data);
            return;
          } else {
            this.filtered_flight_data = this.flight_data;
            this.updateFlightFilter(false, this.filtered_flight_data);
            return;
          } 
      
       }
      if (this.isFilteredViaSearch) {
        this.filtered_flight_data = this.searchFilteredArray.filter((flight) => flight.adi.toLowerCase().trim() === adiValue);
      } else {
        this.filtered_flight_data = this.flight_data.filter((flight) => flight.adi.toLowerCase().trim() === adiValue);
      }
 

    this.updateFlightFilter(true, this.filtered_flight_data);
    this.updateDepartureColumnHeader(openCloseClass);
  }

  updateFlightFilter(shouldBeFiltered, filteredData) {
    this.filteredViaTabbed = shouldBeFiltered;
    this.filtered_flight_data = filteredData;
  }

  updateDepartureColumnHeader(classValue) {
    this.depature_column_header.classList.remove('open');
    this.depature_column_header.classList.remove('close');
    this.depature_column_header.classList.add(classValue);
  }

  tableRowCreator({ airline, airline_logo, number, adi, location, schedule, actual,status }, arrival_depature_class) {
    let row = document.createElement("div");
    row.classList.add("flight-table-row");
    let depature_arrival_status = adi.toLowerCase() === 'd' ? 'Departure' : 'Arrival';
    let flight_status_details = this.processFlightStatus(schedule, actual, status);
    const { statusType, statusClass } = flight_status_details;

    row.innerHTML = `
      <div data-flight-airline="${airline}" class="flight-table-cell airline">
        <img src="${airline_logo}" alt="${airline} Logo">
      </div>
      <span class="flight-table-cell flight">${number}</span>
      <span class="flight-table-cell arrival-departure ${arrival_depature_class}">${depature_arrival_status}</span>
      <span class="flight-table-cell location">${location}</span>
      <span class="flight-table-cell schedule">${short_day_name_and_time(schedule)}</span>
      <span class="flight-table-cell actual">${short_day_name_and_time(actual)}</span>
      <span class="flight-table-cell status ${statusClass}">${statusType}</span>
    </div>`;
    
    return row;
  }

 /**
 * Converts flight schedule and actual time to formatted strings and determines flight status.
 * @param {string} schedule - The scheduled departure/arrival time (in string format).
 * @param {string} actual - The actual departure/arrival time (in string format).
 * @param {string} status - The flight status ('Departed', 'Arrived', or other).
 * @returns {Object} An object containing the following properties:
 *                   - convertedSchedule: The formatted scheduled time.
 *                   - convertedActual: The formatted actual time.
 *                   - statusType: The flight status type ('On Time', 'Arrived', 'Delayed').
 *                   - statusClass: The CSS class to be used for styling ('success' or 'delayed').
 */
processFlightStatus(schedule, actual, status) {
  // Convert status to lowercase for case-insensitive comparison
  status = status.toLowerCase();

 
  // Convert schedule and actual times to formatted strings
  let convertedSchedule = new Date(schedule).toLocaleString('en-US', {
    weekday: 'short',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  });

  let convertedActual = new Date(actual).toLocaleString('en-US', {
    weekday: 'short',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  });

  // Variables to store the flight status type and CSS class
  let statusType, statusClass;
  
  // Check if the flight status is 'departed'
  if (status === 'departed') {
    statusType = 'On Time';
    statusClass = 'success';
  } 
  // Check if the flight status is 'arrived'
  else if (status === 'arrived') {
    statusType = 'Arrived';
    statusClass = 'success';
  }  else if (status === 'cancelled') {
    statusType = 'Cancelled';
    statusClass = 'cancelled';
  }
  // If the flight status is neither 'departed' nor 'arrived', calculate the time difference
  else {
    const timeDifference = new Date(actual) - new Date(schedule);
    // Determine the flight status based on time difference
    statusType = timeDifference > 0 ? 'Delayed' : 'On Time';
    // Set the CSS class based on the flight status
    statusClass = statusType === 'Delayed' ? 'delayed' : 'success';
  }

  // Return an object containing all the flight status details
  return {
    convertedSchedule,
    convertedActual,
    statusType,
    statusClass
  };
}


  searchFlight(e) {
   let search =  this.flight_search.value;
    // Check if the search value is the same as the previous search value
    if (search === this.search_value) {
      return;
    }
    // Update the search value
    this.search_value = search;

    // Clear the table body and display a loading spinner
    this.flight_table_ui.clearTable();
    this.flight_table_ui.displayLoadingSpinner("Searching for flights...");

    clearTimeout(this.search_timer);
    this.search_timer = setTimeout(() => {
      this.filterFlights(search);
    }, 1000);
  }

  filterFlights(search) {
    // Open column header
    this.updateDepartureColumnHeader("open");

    // Filter the flight data based on the search term and active tab
    let filtered_flights = this.flight_data.filter((flight) => {
      let flight_number = flight.number.toLowerCase().trim();
      let location = flight.location.toLowerCase().trim();
      let search_value = search.toLowerCase().trim();
      // Check if the flight number or location matches the search term and if adi matches the active tab
      if (flight_number.includes(search_value) || location.includes(search_value)) {
        return this.activeTab === "All" || flight.adi.toLowerCase().trim() === this.activeTab;
      }
    });

    // Clear the table body
    this.flight_table_ui.clearTable();

    // Check if filtered flights exist
    if (filtered_flights.length > 0) {
      // Append the filtered flights to the table body
      filtered_flights.forEach((flight) => {
        this.flight_table_ui.appendChild(this.tableRowCreator(flight));
      });
      this.searchFilteredArray = filtered_flights;
      this.isFilteredViaSearch = true;
    } else {
      // No flights found, display a message to the user
      this.flight_table_ui.displayNoFlightsMessage();
      this.searchFilteredArray = [];
      this.isFilteredViaSearch = false;
    }
  }

  sortFlights(event) {
    // Extract the target header element from the event
    const header = event.target;

    // Extract the sort key from the 'data-sort_key' attribute of the header
    const sortKey = header.dataset.sort_key.toLowerCase();
    

    // Check if the 'rotate' class is present in the header
    const isRotated = header.classList.contains('rotate');
      // if item isn't rotated search for the rotate class and remove it
      if(!isRotated) {
        this.sortableHeaders.forEach((header) => {
          header.classList.remove('rotate');
        });
      }

    // Toggle the 'rotate' class in the header
    header.classList.toggle('rotate', !isRotated);

    // Return if no sort key is available
    if (!sortKey) {
      return;
    }

    // Create a copy of the flights array based on filtering status
    let sortedFlights = [];
    if (this.filteredViaTabbed && !this.isFilteredViaSearch) {
      sortedFlights = this.filtered_flight_data.slice();
    } else if (this.isFilteredViaSearch) {
      sortedFlights = this.searchFilteredArray.slice();
    } else {
      sortedFlights = this.flight_data.slice();
    }

 
    sortedFlights = sortedFlights.map((flight) => {
      const { convertedSchedule, convertedActual, statusType, statusClass } = this.processFlightStatus(flight.schedule, flight.actual, flight.status);
      
      flight.statustype = statusType;
      
      return flight;
    });
  
    // Sort the flights based on the specified sort key and sorting order
    sortedFlights.sort((a, b) => {
      let valueA = a[sortKey];
      let valueB = b[sortKey];

      if (sortKey === 'number') {
        valueA = parseInt(valueA, 10);
        valueB = parseInt(valueB, 10);

       
      } else {
        valueA = valueA.toLowerCase().trim();
        valueB = valueB.toLowerCase().trim();
         
      }

      if (valueA < valueB) {
        return isRotated ? 1 : -1; // Sort in descending order if 'rotate' class is present
      }
      if (valueA > valueB) {
        return isRotated ? -1 : 1; // Sort in descending order if 'rotate' class is present
      }
      return 0;
    });

    
 
    // Clear the table body
    this.flight_table_ui.clearTable();

    // Append the sorted flights to the table body
    sortedFlights.forEach((flight) => {
      this.flight_table_ui.appendChild(this.tableRowCreator(flight));
    });

    // Update the filtered flights array
    if (this.filteredViaTabbed && !this.isFilteredViaSearch) {
      this.filtered_flight_data = sortedFlights;
    } else if (this.isFilteredViaSearch) {
      this.searchFilteredArray = sortedFlights;
    }
  }
}











 


 



 



















































 














 






 




 





 










 





















 






 



















